<script setup>

const props = defineProps({
  task: { type: Object, required: true },
  expanded: { type: Boolean, default: false },
})
const emit = defineEmits(['toggle'])

function iconByStatus(s) {
  switch (s) {
    case 'ASSIGNED': return 'pi pi-hourglass'
    case 'DONE': return 'pi pi-check-circle'
    case 'DECLINED': return 'pi pi-ban'
    case 'RETURNED': return 'pi pi-undo'
    case 'CLOSED': return 'pi pi-lock'
    default: return 'pi pi-circle'
  }
}

function statusColor(s) {
  switch (s) {
    case 'ASSIGNED': return 'text-blue-400'
    case 'DONE': return 'text-green-300'
    case 'DECLINED': return 'text-red-300'
    case 'RETURNED': return 'text-yellow-400'
    case 'CLOSED': return 'text-gray-400'
    default: return 'text-gray-400'
  }
}
</script>

<template>
  <div class="px-2 py-2 rounded cursor-pointer hover:bg-surface-100" @click="emit('toggle')">
    <!-- 1-я строка: Заголовок + статус -->
    <div class="flex items-center gap-2">
      <i :class="[iconByStatus(task.status), statusColor(task.status)]" class="text-base"></i>
      <span class="font-semibold">{{ task.title }}</span>
    </div>

    <!-- 2-я строка: Срок -->
    <div class="text-sm text-gray-600 mt-1">
      <span v-if="task.due_date">Срок: {{ new Date(task.due_date).toLocaleDateString() }}</span>
    </div>

    <!-- 3-я строка: Участники -->
    <div class="text-sm text-gray-700 mt-1">
      <span>Постановщик: {{ task.creator_name || ('#' + task.creator) }}</span><br>
      <span>Исполнитель: {{ task.assignee_name || ('#' + task.assignee) }}</span>
    </div>

    <!-- 4-я строка: Контекст -->
    <div v-if="task.context" class="text-sm text-gray-700 mt-1">
      {{ task.context.label || (task.context.app_label + '.' + task.context.model) }}:
      <RouterLink
        :to="`/${task.context.app_label}s/${task.context.id}`"
        class="text-primary-600 hover:underline"
        @click.stop
      >
        {{ task.context.name || ('#' + task.context.id) }}
      </RouterLink>
    </div>
  </div>
</template>
